import React from 'react';
import { CobaltIntelligenceCard } from './CobaltIntelligenceCard';
import { CobaltIntelligenceGuard } from './CobaltIntelligenceGuard';

interface Props {
  voId: string;
}

export const CobaltIntelligenceWidget = ({ voId }: Props) => (
  <CobaltIntelligenceGuard>
    <CobaltIntelligenceCard voId={voId} />
  </CobaltIntelligenceGuard>
);
